import { projectsContextDefaultState } from 'src/shared/store/projects/constants';
import { FormType, ProjectType, TableSettingsForm } from 'src/shared/store/projects/types';
import { tableContextDefaultState } from 'src/shared/store/table/constants';
import { ListItem } from 'src/shared/store/table/types';

type ResetWorkspaceStateParams = {
  setProjects: (projects: ProjectType[]) => void;
  setForms: (forms: FormType[]) => void;
  setSelectedProject: (project: ProjectType | null) => void;
  setSelectedForm: (form: FormType | null) => void;
  setTableSettings: (tableSettings: TableSettingsForm | null) => void;
  setTableData: (tableData: ListItem[]) => void;
  setIsProjectsLoading?: (isLoading: boolean) => void;
  setIsFormsLoading?: (isLoading: boolean) => void;
  setIsTableSettingsLoading?: (isLoading: boolean) => void;
};

export const resetWorkspaceState = ({
  setProjects,
  setForms,
  setSelectedProject,
  setSelectedForm,
  setTableSettings,
  setTableData,
  setIsProjectsLoading,
  setIsFormsLoading,
  setIsTableSettingsLoading,
}: ResetWorkspaceStateParams) => {
  setProjects(projectsContextDefaultState.projects);
  setForms(projectsContextDefaultState.forms);
  setSelectedProject(projectsContextDefaultState.selectedProject);
  setSelectedForm(projectsContextDefaultState.selectedForm);
  setTableSettings(projectsContextDefaultState.tableSettings);
  setTableData(tableContextDefaultState.tableData);

  setIsProjectsLoading?.(projectsContextDefaultState.isProjectsLoading);
  setIsFormsLoading?.(projectsContextDefaultState.isFormsLoading);
  setIsTableSettingsLoading?.(projectsContextDefaultState.isTableSettingsLoading);
};
